/* eslint-disable react-hooks/exhaustive-deps */
import { Typography, Grid, Button, Collapse } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import MenuIcon from '@material-ui/icons/Menu';
import { DefaultCard } from 'common/components/cards/DefaultCard';
import { BASE_S3 } from 'config/consts';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CarouselSkeleton from '../../../../../common/components/skeleton/carouselSkeleton';
import VoucherModal from '../../../../../common/components/voucherModal';
import { getListByUserId, setLoading } from './vouchersActions';
import { getDependents } from '../../activities/activitiesActions';

const PAGE_SIZE = 8;

const isUsed = (v) => String(v.validated) === '1';
const getExpiry = (v) =>
  v?.presential_course?.action?.date_validity_voucher ||
  v?.presential_course?.date;
const isExpired = (v) => {
  const exp = getExpiry(v);
  return !isUsed(v) && exp && new Date(exp) < new Date();
};
const fmt = (d) => (d ? moment(d).format('LLLL') : '');

export function Vouchers(props) {
  useEffect(() => {
    const { id, cpf } = props.auth.user;
    props.getListByUserId(id);
    props.getDependents(cpf);
  }, []);

  const [open, setOpen] = useState(false);
  const [voucherItem, setItem] = useState(undefined);
  const [showInativos, setShowInativos] = useState(false);
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const dependenteArray = Array.isArray(props.dependentes)
    ? props.dependentes
    : [props.dependentes];

  const list = props.vouchers.list.content || [];

  const { disponiveis, inativos } = useMemo(() => {
    const disp = list
      .filter((v) => !isUsed(v) && !isExpired(v))
      .sort((a, b) => {
        const ea = getExpiry(a) ? new Date(getExpiry(a)).getTime() : Infinity;
        const eb = getExpiry(b) ? new Date(getExpiry(b)).getTime() : Infinity;
        return ea - eb;
      });
    const inat = list
      .filter((v) => isUsed(v) || isExpired(v))
      .sort(
        (a, b) =>
          new Date(b.updatedAt || b.createdAt) -
          new Date(a.updatedAt || a.createdAt)
      );
    return { disponiveis: disp, inativos: inat };
  }, [list]);

  function selectItem(item) {
    setOpen(true);
    setItem(item);
  }

  if (props.vouchers.loading) {
    return (
      <Grid
        container
        direction="column"
        alignItems="flex-start"
        xs={12}
        spacing={2}
        style={{
          minHeight: '100vh',
        }}
      >
        {Array.from(new Array(5)).map((el) => (
          <Grid
            item
            container
            alignItems="center"
            justifyContent="center"
            xs={12}
          >
            <CarouselSkeleton elementsHeight={150} />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (_.isEmpty(list)) {
    return (
      <section id="vouchers-list">
        <Typography variant="h4">Meus vouchers</Typography>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            minHeight: '92vh',
            backgroundColor: 'transparent',
          }}
        >
          <Typography variant="h6">Você ainda não possui vouchers</Typography>
        </div>
      </section>
    );
  }

  const renderDisponivelDescription = (item) => {
    const exp = getExpiry(item);
    return exp ? `Expira em: ${fmt(exp)}` : '';
  };

  const renderInativoDescription = (item) => {
    if (isUsed(item)) {
      return `Utilizado em: ${fmt(item.updatedAt || item.createdAt)}`;
    }
    return `Expirou em: ${fmt(getExpiry(item))}`;
  };

  return (
    <>
      <section
        id="vouchers-list"
        style={{
          backgroundColor: 'transparent',
          minHeight: '100vh',
        }}
      >
        <Typography variant="h4">Meus vouchers</Typography>
        <div className="container-fluid px-4 pt-4">
          <div className="row">
            {disponiveis.length === 0 ? (
              <Grid
                item
                container
                xs={12}
                justifyContent="center"
                style={{ padding: '2rem 0' }}
              >
                <Typography variant="body1">
                  Você não tem vouchers disponíveis no momento.
                </Typography>
              </Grid>
            ) : (
              disponiveis.map((item, index) => (
                <div
                  key={`av-${item.id ?? index}`}
                  className="mb-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"
                  style={{ cursor: 'pointer' }}
                  onClick={() => selectItem(item)}
                >
                  <DefaultCard
                    imgSource={`${BASE_S3}/${item.presential_course.action.image}`}
                    actionName={fmt(item.createdAt)}
                    description={renderDisponivelDescription(item)}
                    labelClick="Ver Voucher"
                  />
                </div>
              ))
            )}
          </div>

          {inativos.length > 0 && (
            <div style={{ marginTop: '1.5rem' }}>
              <Grid
                container
                alignItems="center"
                onClick={() => setShowInativos((s) => !s)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#E0E0E0',
                  padding: '12px 16px',
                  borderRadius: 4,
                }}
              >
                <MenuIcon style={{ marginRight: 12 }} />
                <Typography
                  variant="subtitle1"
                  style={{ flexGrow: 1, fontWeight: 500 }}
                >
                  Vouchers utilizados/expirados
                </Typography>
                {showInativos ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Grid>
              <Collapse in={showInativos} timeout="auto" unmountOnExit>
                <div className="row" style={{ marginTop: '1rem' }}>
                  {inativos.slice(0, visibleCount).map((item, index) => (
                    <div
                      key={`in-${item.id ?? index}`}
                      className="mb-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"
                      style={{
                        cursor: 'pointer',
                        filter: 'grayscale(100%)',
                        opacity: 0.7,
                      }}
                      onClick={() => selectItem(item)}
                    >
                      <DefaultCard
                        imgSource={`${BASE_S3}/${item.presential_course.action.image}`}
                        actionName={
                          isUsed(item)
                            ? 'Este voucher já foi utilizado!'
                            : 'Este voucher expirou!'
                        }
                        description={renderInativoDescription(item)}
                        labelClick="Ver Voucher"
                      />
                    </div>
                  ))}
                </div>
                {inativos.length > visibleCount && (
                  <Grid
                    container
                    justifyContent="center"
                    style={{ marginBottom: '1.5rem' }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() =>
                        setVisibleCount((c) => c + PAGE_SIZE)
                      }
                    >
                      Carregar mais vouchers utilizados/expirados
                    </Button>
                  </Grid>
                )}
              </Collapse>
            </div>
          )}
        </div>
      </section>
      {voucherItem ? (
        <VoucherModal
          user={props.auth.user}
          open={open}
          setOpen={setOpen}
          item={voucherItem}
          dependentes={dependenteArray}
        />
      ) : null}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    vouchers: state.vouchers,
    dependentes: state.activities.dependents.content,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListByUserId,
      setLoading,
      getDependents,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Vouchers);
